import { useMemo } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { MONTH_NAMES } from 'itrvl-types';
import EdgeAvailabilityCalendar from './EdgeAvailabilityCalendar';

const DEFAULT_YEAR_RANGE = 3;

const wrapperSx = {
  backgroundColor: 'stoneGrey.white40',
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 2,
};

const innerSx = {
  borderTop: '1px solid',
  borderColor: 'divider',
  px: 3,
  pt: 3,
  pb: 2,
};

export default function EdgeCalendarPicker({
  month,
  onMonthChange,
  year,
  onYearChange,
  yearOptions: yearOptionsProp,
  children,
  sx,
  ...calendarProps
}) {
  const yearOptions = useMemo(() => {
    if (yearOptionsProp) return yearOptionsProp;
    const now = new Date().getFullYear();
    return Array.from({ length: DEFAULT_YEAR_RANGE }, (_, i) => now + i);
  }, [yearOptionsProp]);

  return (
    <Stack sx={{ ...wrapperSx, ...sx }}>
      <Stack direction="row" gap={1} sx={{ p: 1.5 }}>
        <Select
          value={month}
          onChange={e => onMonthChange(e.target.value)}
          size="small"
          fullWidth
          inputProps={{ 'aria-label': 'Month' }}
          sx={{ backgroundColor: 'background.paper' }}
        >
          {MONTH_NAMES.map((name, idx) => (
            <MenuItem key={name} value={idx}>
              {name}
            </MenuItem>
          ))}
        </Select>
        <Select
          value={year}
          onChange={e => onYearChange(e.target.value)}
          size="small"
          fullWidth
          inputProps={{ 'aria-label': 'Year' }}
          sx={{ backgroundColor: 'background.paper' }}
        >
          {yearOptions.map(y => (
            <MenuItem key={y} value={y}>
              {y}
            </MenuItem>
          ))}
        </Select>
      </Stack>
      {children || (
        <Box sx={innerSx}>
          <EdgeAvailabilityCalendar {...calendarProps} />
        </Box>
      )}
    </Stack>
  );
}
